<template>
  <div class="absolute top-0 right-0 h-screen w-screen max-w-5xl">
    <div
      class="relative flex h-full flex-col overflow-y-scroll bg-ontick-carbon-500 bg-opacity-90 shadow-xl backdrop-blur-sm backdrop-opacity-90 backdrop-filter"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {},

  methods: {},
};
</script>
<style lang="scss"></style>
